<template>
    <div class="modal-overlay">
        <div
            :class="{ 'modals modals-center': true, show: true, 'modals-import new payment-modal': true }"
            v-on-clickaway="close"
            style="z-index:1000;"
        >
            <div class="modals-content">
                <div class="search-content" v-show="!showLoader">
                    <div class="modal-title">
                        You’re deleting an event!
                    </div>
                    <p>
                        Do you want to delete?
                    </p>
                    <div class="modals-footer" v-if="show_delete_all">
                        <a :class="{ 'btn btn-default right save-btn': true }" @click="remove_event('this')"
                            >This event</a
                        >
                        <a :class="{ 'btn btn-default right save-btn': true }" @click="remove_event('following')"
                            >This and following events</a
                        >
                        <a :class="{ 'btn btn-primary left save-btn': true }" @click="remove_all_events">All events</a>
                        <a :class="{ 'btn-link': true }" href="javascript:{}" @click="close()">Cancel</a>
                    </div>
                    <div class="modals-footer" v-else>
                        <a :class="{ 'btn btn-primary right save-btn': true }" @click="remove_events">This event</a>
                        <a :class="{ 'btn-link': true }" href="javascript:{}" @click="close()">Cancel</a>
                    </div>
                </div>
                <div class="loading-container" v-show="showLoader">
                    <div id="loading"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mixin as clickaway } from "vue-clickaway";
import { mapActions } from "vuex";

export default {
    name: "event-delete-modal",
    props: ["shown", "event", "show_delete_all"],
    mixins: [clickaway],
    mounted() {},
    computed: {},
    data() {
        return {
            showLoader: false,
            disabled: true
        };
    },
    methods: {
        ...mapActions("StoreEvent", ["delete_event", "delete_recurring_event"]),
        close(ce) {
            this.$nextTick(() => {
                this.$emit("close-modal");
            });
        },
        remove_event(type = false) {
            let data = {
                event: this.event
            };
            if (type) {
                data["type"] = type;
            }
            this.delete_recurring_event(data);
        },
        remove_all_events() {
            this.remove_event("all");
        },
        remove_events() {
            if (!this.event.recurring) {
                this.delete_event(this.event.id);
            } else {
                this.remove_event("this");
            }
        }
    }
};
</script>
<style scoped>
.modals-footer {
    margin-top: 16px;
}

.modal-overlay {
    position: fixed; /* Stay in place */
    z-index: 132; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.75); /* Black w/ opacity */
}

h2 {
    margin-bottom: 0rem;
    font-size: 1.6rem;
}

.modals-close {
    display: flex;
    margin-left: auto;
}

.modals-close a,
.modals-name {
    display: flex;
}

.btn-default {
    padding: 0.6rem 1.4rem;
}
.modals-head {
    display: flex;
    border-bottom: 0.1rem solid #dbdbdb;
}

.btn {
    margin-top: 0.9rem;
    margin-bottom: 0.9rem;
}

.btn:first-child {
    margin-top: 0;
    margin-bottom: 0.9rem;
}

.btn:last-child {
    margin-top: 0px;
    margin-bottom: 0.9rem;
}

h2 {
    margin-bottom: 0rem;
    font-size: 1.6rem;
}

.btn-link,
.btn-link:hover,
.btn-link:active,
.btn-link:visited {
    text-align: center;
    font-weight: bold;
    font-size: 1.1rem;
    line-height: 2.4rem;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: #00a8b3;
    margin-top: 1.5rem;
    cursor: pointer;
    cursor: pointer;
    display: flex;
    text-align: center;
    justify-content: center;
    text-decoration: none;
}

.modals-footer {
    display: flex;
    margin-bottom: 16px;
    justify-content: center;
}

.modals-footer {
    display: flex;
    margin-bottom: 0px;
    justify-content: center;
    flex-direction: column;
    padding: 0 5.2rem;
}

@media (max-width: 820px) {
    .modals-footer {
        padding: 0rem;
    }
}

.modal-title {
    display: flex;
    justify-content: center;
    font-weight: 600;
    font-size: 1.4rem;
    line-height: 2.4rem;
    margin-bottom: 1.6rem;
    text-align: center;
}

.search-content p {
    font-size: 1.2rem;
    line-height: 2.4rem;
    text-align: center;
    letter-spacing: 0.02em;
    margin-bottom: 3.2rem;
}

.modals {
    border-radius: 4px;
    background-color: #fefefe;
    margin: 15% auto; /* 15% from the top and centered */
    width: 40rem; /* Could be more or less, depending on screen size */
    max-width: 90%;
}

.modals-content {
    padding: 4rem;
}
</style>
